<template>
    <svg :viewBox="viewBox" fill="currentColor" aria-hidden="true">
        <template v-for="(shape, index) in shapes">
            <circle
                v-if="shape.type === 'circle'"
                :key="index"
                :cx="shape.cx"
                :cy="shape.cy"
                :r="shape.r"
                :opacity="shape.opacity"
            />
            <rect
                v-else
                :key="index"
                :x="shape.x"
                :y="shape.y"
                :width="shape.width"
                :height="shape.height"
                :rx="shape.rx"
                :opacity="shape.opacity"
            />
        </template>
        <text
            v-for="(item, index) in labels"
            :key="`label-${index}`"
            :x="item.x || 16"
            :y="item.y"
            class="silhouette-label"
        >
            {{ item.text }}
        </text>
    </svg>
</template>

<script>
import { DISPLAY_MODE_SILHOUETTE_VIEW_BOX } from "@/common/fields/display-modes";

export default {
    name: "DisplayModeSilhouette",
    props: {
        shapes: {
            type: Array,
            default: () => []
        },
        viewBox: {
            type: String,
            default: DISPLAY_MODE_SILHOUETTE_VIEW_BOX
        },
        labels: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style>
/* El tamaño va en unidades del viewBox, no en px: Tailwind no alcanza. */
.silhouette-label {
    font-size: 7px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    opacity: 0.75;
}
</style>
